/**
 * isiZulu: Voice
 *
 * What this file covers: Phone numbers, calls, recordings and the phone assistant.
 *
 * Tone: Clear and reassuring. Recording and consent wording is legal in effect: translate it exactly.
 *
 * isiZulu: Everyday isiZulu as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const voice: Catalog = {};

export default voice;
